import React from 'react'
import BrandingSection1 from '../sections/BrandingSection1'
import { AwardsComponent } from './Home'
import PerspectiveHoverWrapper from '../components/PerspectiveHoverWrapper'
import HomeServicesVerticalSection from '../sections/HomeServicesVerticalSection'
import { Outlet } from 'react-router-dom'


const Card = ({ data }) => {
    return (
        <>
            <div className='w-full h-auto overflow-hidden rounded group pointer-events-auto relative'>
                <div className='h-full w-full overflow-hidden'>
                    <img
                        src={data.src}
                        className=' h-full w-full object-cover'
                        alt="" />
                </div>
                <div className="absolute h-[30%] bottom-0 w-full bg-gradient-to-t from-black/80 to-transparent"></div>
                <div className="absolute left-5 bottom-5 w-full ">
                    <h1 className='text-2xl font-semibold'>{data.heading}</h1>
                    <div className='relative overflow-hidden'>
                        <h4 className='group-hover:-translate-y-[100%] duration-300 '>Home</h4>
                        <h4 className='absolute top-full left-0 group-hover:top-0 duration-300'>Show project</h4>
                    </div>
                </div>
            </div>
        </>
    )
}


const cardData = [
    {
        heading: "Branding",
        src: "https://flamingo-agency.com/wp-content/uploads/2024/08/portada-web-epos-scaled.jpg"
    },
    {
        heading: "Branding",
        src: "https://flamingo-agency.com/wp-content/uploads/2024/08/ecija-advisory-scaled.jpg"
    },
    {
        heading: "Branding",
        src: "https://flamingo-agency.com/wp-content/uploads/2024/08/sofia-zaga-masri-scaled.jpg"
    },
    {
        heading: "Branding",
        src: "https://flamingo-agency.com/wp-content/uploads/2024/08/buenos-aires-campanas.jpg"
    },
    {
        heading: "Branding",
        src: "https://flamingo-agency.com/wp-content/uploads/2024/08/IAM-scaled.jpg"
    },
    {
        heading: "Branding",
        src: "https://flamingo-agency.com/wp-content/uploads/2024/08/oh-wear.jpg"
    },
    {
        heading: "Branding",
        src: "https://flamingo-agency.com/wp-content/uploads/2024/08/julio-torres-2-scaled.jpg"
    },
    {
        heading: "Branding",
        src: "https://flamingo-agency.com/wp-content/uploads/2024/08/EVOLVIS-AI-scaled.jpg"
    },
]

const Services = () => {
    return (
        <>
            <AwardsComponent />
            <div className='dark:bg-zinc-900 text-white min-h-screen w-full relative z-20flex gap-10 py-20'>

                {/* <div className="left space-y-10 ">
                    {cardData.slice(0, 4).map((item, index) => (
                        <PerspectiveHoverWrapper key={index} maxRotation={5} >
                            <Card key={index} data={item} />
                        </PerspectiveHoverWrapper>
                    ))}
                </div>
                <div className="right space-y-10 ">
                    {cardData.slice(4, 8).map((item, index) => (
                        <PerspectiveHoverWrapper key={index} maxRotation={5} >
                            <Card key={index} data={item} />
                        </PerspectiveHoverWrapper>
                    ))}
                </div> */}

                <HomeServicesVerticalSection />

                <Outlet />

            </div>
        </>
    )
}

export default Services